const intitalState = {
  alerts: null,
  loadingAlerts : false,
  endOfAlertsReached: false,
  nbOfAlerts: 0,
  new_alerts : 0
};

export const alertsReducers = (state = intitalState, action) => {
  switch (action.type) {

  case "GET_NEW_ALERTS_SUCCESS":
    return {
      ...state,
      new_alerts: action.new_alerts,
    };
    case "GET_ALERTS_LOADING":
      return {
        ...state,
        loadingAlerts: true,
      };
    case "GET_ALERTS_SUCCESS":
      return {
        ...state,
        alerts: action.alerts,
        loadingAlerts: false,
        nbOfAlerts: action.nbOfAlerts,
        endOfAlertsReached: action.endOfAlertsReached
      };
    case "GET_MORE_ALERTS_SUCCESS":
      let alerts = state.alerts.concat(action.alerts);
      return {
        ...state,
        alerts: alerts,
        loadingAlerts: false,
        nbOfAlerts: action.nbOfAlerts,
        endOfAlertsReached: action.endOfAlertsReached
      };
    default:
      return state;
  }
};
